import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapActions } from 'vuex';
import setRules from '@/libs/rules';
var rule = [{
  key: 'oldVerifyCode',
  name: '当前手机验证码',
  validator: 'validateNumber'
}, {
  key: 'accountPhone',
  name: '新手机号码',
  validator: 'validatePhone'
}, {
  key: 'verifyCode',
  name: '新手机验证码',
  validator: 'validateNumber'
}];
import { cloneDeep } from 'lodash';
var initForm = {
  accountPhone: '',
  verifyCode: '',
  oldVerifyCode: ''
};
export default {
  meta: {
    title: '修改手机号',
    auth: true,
    authorityValue: "store-router-page"
  },
  name: 'editPhone',
  data: function data() {
    return {
      //验证码等待时间
      time: 60,
      timeInterval: null,
      getCodeText: '获取验证码',
      getCodeDisabled: false,
      oldTime: 60,
      oldTimeInterval: null,
      getOldCodeText: '获取验证码',
      getOldCodeDisabled: false,
      // 表单
      formLogin: cloneDeep(initForm),
      // 表单校验
      rules: setRules(rule),
      cookiesName: ''
    };
  },
  mounted: function mounted() {
    var oldSendEndTime = YL.cookies.get("YL_PHONE_VerifyCode_old");
    if (oldSendEndTime) this.getCodePhone();
    var newSendEndTime = YL.cookies.get("YL_PHONE_VerifyCode_new");
    if (newSendEndTime) this.getNewCodePhone();
  },
  computed: _objectSpread(_objectSpread({}, mapState('d2admin/user', ['info'])), {}, {
    oldPhone: function oldPhone() {
      var _this$info;

      return (_this$info = this.info) === null || _this$info === void 0 ? void 0 : _this$info.accountPhone;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/account', ['logout'])), {}, {
    //验证当前手机号
    verifyPhoneCode: function verifyPhoneCode() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.verifyPhoneCode({
                  accountPhone: _this.oldPhone
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    isPoneAvailable: function isPoneAvailable($poneInput) {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;

      if (!myreg.test($poneInput)) {
        this.$message.error('请输入正确的手机号');
        return false;
      } else {
        return true;
      }
    },
    //获取手机验证码
    getCode: function getCode(phone) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$api.updatePhoneVerifyCode({
                  accountPhone: phone
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    //获取新手机验证码倒计时
    getNewCodePhone: function getNewCodePhone() {
      var _this3 = this;

      var phone = this.formLogin.accountPhone;
      if (!this.isPoneAvailable(phone)) return;
      var getCookiesTime = YL.cookies.get("YL_PHONE_VerifyCode_new");
      var nowTime = new Date().getTime();

      if (getCookiesTime) {
        var surplus = 60 - parseInt((nowTime - getCookiesTime) / 1000, 10);
        this.time = surplus <= 0 ? 0 : surplus;
      } else {
        this.time = 60;
        YL.cookies.set("YL_PHONE_VerifyCode_old", nowTime);
        this.getCode(phone);
      }

      if (this.getCodeDisabled) return;
      this.timeInterval = setInterval(function () {
        _this3.time--;
        _this3.getCodeText = _this3.time + '秒';
        _this3.getCodeDisabled = true;

        if (_this3.time <= 0) {
          _this3.getCodeDisabled = false;
          YL.cookies.remove("YL_PHONE_VerifyCode_new");
          clearInterval(_this3.timeInterval);
          _this3.time = 60;
          _this3.getCodeText = '获取验证码';
        }
      }, 1000);
    },
    //获取旧手机验证码倒计时
    getCodePhone: function getCodePhone() {
      var _this4 = this;

      var getCookiesTime = YL.cookies.get("YL_PHONE_VerifyCode_old");
      var nowTime = new Date().getTime();

      if (getCookiesTime) {
        var surplus = 60 - parseInt((nowTime - getCookiesTime) / 1000, 10);
        this.oldTime = surplus <= 0 ? 0 : surplus;
      } else {
        this.oldTime = 60;
        YL.cookies.set("YL_PHONE_VerifyCode_old", nowTime);
        this.verifyPhoneCode();
      }

      if (this.getOldCodeDisabled) return;
      this.oldTimeInterval = setInterval(function () {
        _this4.oldTime--;
        _this4.getOldCodeText = _this4.oldTime + '秒';
        _this4.getOldCodeDisabled = true;

        if (_this4.oldTime <= 0) {
          _this4.getOldCodeDisabled = false;
          YL.cookies.remove("YL_PHONE_VerifyCode_old");
          clearInterval(_this4.oldTimeInterval);
          _this4.oldTime = 60;
          _this4.getOldCodeText = '获取验证码';
        }
      }, 1000);
    },

    /**
     * @description 提交表单
     */
    submit: function submit() {
      var _this5 = this;

      this.$refs.loginForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!valid) {
                    _context3.next = 5;
                    break;
                  }

                  _context3.next = 3;
                  return _this5.$api.updatePhone(_this5.formLogin);

                case 3:
                  _this5.$notify.success({
                    title: '成功',
                    message: '修改成功,重新登陆'
                  });

                  _this5.logout({
                    confirm: false
                  });

                case 5:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  })
};